export const BRAND = "RismaCell";
export const WHATSAPP_NUMBER = "6285710525712";
export const INDIHOME_LOGO =
  "https://upload.wikimedia.org/wikipedia/commons/5/5b/IndiHome_logo.svg";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Halo RismaCell, saya mau tanya jasa migrasi paket retensi Indihome."
)}`;

// Fee jasa migrasi (sekali bayar) berdasarkan kecepatan paket yang dituju
export const migrationFee = (speed) => {
  const mbps = parseInt(speed, 10);
  if (mbps <= 20) return 85000;
  if (mbps <= 200) return 150000;
  return 220000;
};

export const PACKAGE_GROUPS = [
  {
    id: "1p",
    name: "Internet Only (1P)",
    items: [
      { speed: "10 Mbps", price: 140000 },
      { speed: "20 Mbps", price: 160000 },
      { speed: "50 Mbps", price: 170000 },
      { speed: "100 Mbps", price: 180000 },
      { speed: "150 Mbps", price: 200000 },
      { speed: "200 Mbps", price: 220000 },
      { speed: "300 Mbps", price: 240000 },
    ],
  },
  {
    id: "2p-telp",
    name: "Internet + Telepon (2P)",
    items: [
      { speed: "50 Mbps", price: 190000 },
      { speed: "100 Mbps", price: 200000 },
      { speed: "150 Mbps", price: 220000 },
      { speed: "200 Mbps", price: 240000 },
      { speed: "300 Mbps", price: 260000 },
    ],
  },
  {
    id: "2p-tv",
    name: "Internet + TV (2P)",
    items: [
      { speed: "50 Mbps", price: 240000 },
      { speed: "100 Mbps", price: 250000 },
      { speed: "150 Mbps", price: 270000 },
      { speed: "200 Mbps", price: 290000 },
      { speed: "300 Mbps", price: 310000 },
    ],
  },
  {
    id: "3p",
    name: "Internet + TV + Telepon (3P)",
    items: [
      { speed: "50 Mbps", price: 260000 },
      { speed: "100 Mbps", price: 270000 },
      { speed: "150 Mbps", price: 290000 },
      { speed: "200 Mbps", price: 310000 },
      { speed: "300 Mbps", price: 330000 },
    ],
  },
];

export const MIGRATION_FEE_TIERS = [
  { label: "Paket 10 & 20 Mbps", fee: 85000 },
  { label: "Paket 50 - 200 Mbps", fee: 150000 },
  { label: "Paket 300 Mbps", fee: 220000 },
];

// Daftar flat untuk dropdown paket yang dituju
export const DESIRED_PACKAGES = PACKAGE_GROUPS.flatMap((g) =>
  g.items.map((i) => ({
    value: `${g.name} — ${i.speed}`,
    label: `${g.name} — ${i.speed} (Rp ${i.price.toLocaleString("id-ID")}/bulan)`,
  }))
);

export const CURRENT_PACKAGES = [
  "1P (Internet Only)",
  "2P (Internet + TV)",
  "2P (Internet + Phone)",
  "3P (Internet + TV + Phone)",
  "Belum tahu / lupa",
];

export const BILL_PAYMENT_METHODS = [
  "myIndiHome",
  "ATM / Mobile Banking",
  "Minimarket (Indomaret/Alfamart)",
  "E-wallet (Dana/OVO/GoPay/dll)",
  "Belum bayar bulan ini",
  "Lainnya",
];

export const ORDER_REQUIREMENTS = [
  "Berlangganan IndiHome minimal sudah 6 bulan dari awal pemasangan",
  "Sudah melunasi tagihan bulan ini",
];
